import * as React from "react";

export const componentClassNameWrapper = (className: string | undefined) => (WrappedComponent: React.ComponentType) => {
  const Extended = (props: JSX.IntrinsicAttributes) => {
    return  <div className={className} ><WrappedComponent {...props} /></div>
  };
  return Extended;
}

export default componentClassNameWrapper;